import type { ApiMenuItem } from "@/features/theme/types/brandTheme.type";

const isLocations = (it: ApiMenuItem) =>
  it.key === "locations" || it.key?.startsWith("locations-collection-");

// Réordonne UN niveau : place le bloc « Locations » (parent hidden +
// collections injectées) juste AVANT « Mes commandes » — donc
// « Mes commandes » reste le dernier item, après Livres / Mobil homes.
// Fallback : juste après « Bons plans » si « Mes commandes » est absent
// à ce niveau.
const reorderLevel = (list: ApiMenuItem[]): ApiMenuItem[] => {
  const locationsBlock = list.filter(isLocations);
  if (locationsBlock.length === 0) return list;

  const rest = list.filter((it) => !isLocations(it));
  const commandesIdx = rest.findIndex((it) => it.key === "mes_commandes");
  const bonsIdx = rest.findIndex((it) => it.key === "bons_plans");
  let insertAt = -1;
  if (commandesIdx >= 0) insertAt = commandesIdx;
  else if (bonsIdx >= 0) insertAt = bonsIdx + 1;

  if (insertAt < 0) return list;

  const out = [...rest];
  out.splice(insertAt, 0, ...locationsBlock);
  return out;
};

// ADM-652 : « Mes commandes » doit être en dernier, après les collections
// de Location (Livres, Mobil homes…). Le menu API est imbriqué (les items
// Boutique — bons plans, mes commandes, locations — sont les enfants d'un
// groupe « Boutique »), donc on réordonne à CHAQUE niveau (récursif),
// pas seulement à la racine — sinon le bloc locations niché dans les
// enfants n'est jamais déplacé.
export const reorderLocationsSlot = (items: ApiMenuItem[]): ApiMenuItem[] =>
  reorderLevel(items).map((it) =>
    (it.children?.length ? { ...it, children: reorderLocationsSlot(it.children) } : it),
  );
